import { Button } from './Button'
import { Container } from './Container'

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-50 via-white to-white">
      <div className="absolute inset-x-0 top-0 -z-10 h-96 bg-[radial-gradient(circle_at_top,rgba(59,130,246,0.18),transparent_55%)]" />

      <Container className="pt-24 pb-20 text-center lg:pt-32 lg:pb-28">
        <p className="mx-auto mb-6 inline-flex rounded-full bg-blue-50 px-4 py-2 text-sm font-medium text-blue-700 ring-1 ring-blue-100">
          AI text detection for uncertain digital spaces
        </p>

        <h1 className="mx-auto max-w-5xl font-display text-5xl font-semibold tracking-tight text-slate-950 sm:text-7xl">
          Detect AI-written text with clearer, more honest signals.
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-slate-600">
          Digitalfalse helps identify patterns commonly found in machine-generated writing, giving teams a faster way to review suspicious text.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button href="#get-started-today" color="blue">
            Try the detector
          </Button>
          <Button href="mailto:info@digitalfalse.ai" variant="outline">
            Contact us
          </Button>
        </div>

        <p className="mx-auto mt-12 max-w-xl text-sm text-slate-500">
          Our models continue to improve as more examples are reviewed. Known-source submissions help us refine classification quality.
        </p>
      </Container>
    </section>
  )
}